<template>
  <div id='app'>

    <router-view v-wechat-title="$route.meta.title"></router-view>
    <!-- <van-tabbar v-model="active">
      <van-tabbar-item to="/home"
                       icon="wap-home">首页</van-tabbar-item>
      <van-tabbar-item to="/category"
                       icon="birthday-privilege"
                       dot>分类</van-tabbar-item>
      <van-tabbar-item to="/cart"
                       icon="cart"
                       :info="cartCount>0?cartCount:''">购物车</van-tabbar-item>
      <van-tabbar-item to="/my"
                       icon="contact">我的</van-tabbar-item>
    </van-tabbar> -->
  </div>
</template>

<script>
import store from '@/vuex/store'
import { mapState } from 'vuex'
import { debug, debuglog } from 'util';
import { constants } from 'fs';
export default {
  store,
  data () {
    return {
      active: 0,
      cartCount: ''
    }
  },
  watch: {
    // 监听路由跳转。
    $route (newRoute, oldRoute) {
      console.log('watch', newRoute.name, oldRoute.name);
      this.$store.commit('getNewRouteName', newRoute.name);
      this.$store.commit('getOldRouteName', oldRoute.name);

      console.log('231312312:' + this.$store.state.oldRouteName, this.$store.state.newRouteName);
      //this.pageBack();
    },
  },
  created () {
    //方法外见

  },
  computed: {
    ...mapState({
      selectGoods: state => state.selectGoods//绑定store.selectGoods到组件，之后可用this.selectGoods获取
    })
  },
  mounted () {
    this.upDateCount();
    window['pageBack'] = () => {
      this.pageBack();
    }
  },
  methods: {
    //更新购物车数量
    upDateCount () {
      let num = 0;
      this.selectGoods.forEach((item, index) => {
        num += item.count;
      });
      this.cartCount = String(num)
    },
    pageBack () {
      var currentRoute = this.$route.name;
      console.log('currentRoute:::' + currentRoute)
      if (currentRoute == 'detail') {
        //图文详情
        debugger
        if (this.$store.state.isshow_detail == true) {
          this.$store.commit('closeDetailP', false);
          this.backToHome();
        } else {
          this.$store.commit('closeDetailP', true);
          this.$store.commit('isshow_detail', true);
        }
      } else if (currentRoute == '/pay') {
        debugger
        var isDetailOrCart = this.$route.params.isDetailOrCart;
        if (isDetailOrCart == 0) {
          this.backToDetail();
        } else {
          this.backToCart();
        }
      } else if (currentRoute == 'submit_pay') {
        this.backToPay();
        // alert('ghdsfgysdf1462365445555555n5');
      } else if (currentRoute == '/paysuc') {
        this.backToMy();
      } else if (currentRoute == 'cart') {
        this.backToMy();
      } else if (currentRoute == 'bookmark') {
        this.backToMy();
      } else if (currentRoute == '/orderList') {
        this.backToMy();
      } else if (currentRoute == 'listDetail') {
        this.backToOrder();
      } else if (currentRoute == 'addressList') {
        this.backToMy();
      } else if (currentRoute == 'addAddress') {
        this.backToAddress();
      } else if (currentRoute == 'my') {
        this.backToHome();
      }
      else if (currentRoute == '/home_search') {
        this.backToHome();
      }
    }
  }
}
</script>


<style lang="less">
@import "./assets/css/base.less";
@import "./assets/css/reset.css";
#app {
  font-family: "Microsoft Yahei", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;
  color: #2c3e50;
  margin-top: 60px;*/
}
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.24rem;
  span {
    margin-left: 2%;
    color: #666;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue